import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const slackTemplate = {
	id: 'slack',
	guid: '05a68e8f-d319-402c-ae61-3f3a8a4ec4bb',
	name: 'Slack',
	category: TEMPLATE_CATEGORIES.COMMUNICATION,
	popularity: 'Popular',
	color: '#4a154b',
	icon: 'mdi-slack',
	description: 'Team communication platform for notifications and workflow automation.',
	features: ['OAuth2 Auth', 'Message Sending', 'Channel Management', 'Bot Integration'],
	endpoints: [
		{
			name: 'Send a Message - Failed Connector Service Message',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel advising of a failed Connector Service message',
			cassieObjectID: -1,
			incrementField: 'FailureID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ServiceName', filter: '' },
				{ name: 'FailureID', filter: '' },
				{ name: 'OriginalResponseCode', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "Connector Service System [PLACEHOLDER_SERVICENAME] has a failed message with ID [PLACEHOLDER_FAILUREID].  The HTTP response code is [PLACEHOLDER_ORIGINALRESPONSECODE]." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - Failed Submissions',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel advising of a failed Syrenis submission',
			cassieObjectID: -2,
			incrementField: 'SubmissionID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ErrorNumber', filter: '' },
				{ name: 'ErrorMessage', filter: '' },
				{ name: 'SubmissionID', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "The Syrenis API returned the following error details, [PLACEHOLDER_ERRORNUMBER], [PLACEHOLDER_ERRORMESSAGE]." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - New Cookie(s) Found',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel advising of a new Cookie found following a recurring scan',
			cassieObjectID: -8,
			incrementField: 'ScanResultDateTime',
			resetIncrementValue: false,
			fields: [
				{ name: 'ScanID', filter: '' },
				{ name: 'CookieName', filter: '' },
				{ name: 'PreviousScanID', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "The current scan no. [PLACEHOLDER_SCANID] found Cookie with name \'[PLACEHOLDER_COOKIENAME]\' which wasn\'t present in scan no. [PLACEHOLDER_PREVIOUSSCANID].  Please investigate.." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - New Privacy Request',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel when a new privacy request is submitted',
			cassieObjectID: -13,
			incrementField: 'ID',
			resetIncrementValue: false,
			fields: [
				{ name: 'RequestNumber', filter: '' },
				{ name: 'Reference', filter: '' },
				{ name: 'RequestTypeName', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "New privacy request [PLACEHOLDER_REQUESTNUMBER] (reference [PLACEHOLDER_REFERENCE]) of type [PLACEHOLDER_REQUESTTYPENAME] was submitted." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - Data Subject Message',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel when a data subject writes from the request status page',
			cassieObjectID: -14,
			incrementField: 'ID',
			resetIncrementValue: false,
			fields: [
				{ name: 'RequestNumber', filter: '' },
				{ name: 'Reference', filter: '' },
				{ name: 'CommentText', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "New message from the data subject on privacy request [PLACEHOLDER_REQUESTNUMBER] (reference [PLACEHOLDER_REFERENCE]):", "attachments": [{ "text": "[PLACEHOLDER_COMMENTTEXT]" }] }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - Request/Task Nearing Deadline',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send an escalation message to a Slack Channel when a privacy request or task enters its warning window',
			cassieObjectID: -16,
			incrementField: 'ID',
			resetIncrementValue: false,
			fields: [
				{ name: 'EventTitle', filter: '' },
				{ name: 'RequestNumber', filter: '' },
				{ name: 'Reference', filter: '' },
				{ name: 'DaysUntilDue', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "[PLACEHOLDER_EVENTTITLE]: privacy request [PLACEHOLDER_REQUESTNUMBER] (reference [PLACEHOLDER_REFERENCE]) is due in [PLACEHOLDER_DAYSUNTILDUE] day(s)." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - Deadline Breached',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send an escalation message to a Slack Channel when a privacy request or task passes its statutory deadline',
			cassieObjectID: -17,
			incrementField: 'ID',
			resetIncrementValue: false,
			fields: [
				{ name: 'EventTitle', filter: '' },
				{ name: 'RequestNumber', filter: '' },
				{ name: 'Reference', filter: '' },
				{ name: 'DaysOverdue', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "[PLACEHOLDER_EVENTTITLE]: privacy request [PLACEHOLDER_REQUESTNUMBER] (reference [PLACEHOLDER_REFERENCE]) is [PLACEHOLDER_DAYSOVERDUE] day(s) overdue." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - Inactive Request',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel when a privacy request has gone inactive',
			cassieObjectID: -18,
			incrementField: 'ID',
			resetIncrementValue: false,
			fields: [
				{ name: 'RequestNumber', filter: '' },
				{ name: 'Reference', filter: '' },
				{ name: 'Reason', filter: '' },
				{ name: 'DaysSinceLastActivity', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "Privacy request [PLACEHOLDER_REQUESTNUMBER] (reference [PLACEHOLDER_REFERENCE]) is inactive ([PLACEHOLDER_REASON]) - no activity for [PLACEHOLDER_DAYSSINCELASTACTIVITY] day(s)." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		}
	],
	defaults: {
		endpointAddress: 'https://slack.com/api',
		authenticationUrl: 'https://slack.com/oauth/v2/authorize',
		authenticationTypeId: AUTH_TYPES.OAUTH2_CLIENT_CREDENTIALS,
		frequencyInSeconds: 0,
		auth2Scope: 'chat:write,channels:read,users:read',
		notes: 'Slack team communication integration for sending notifications and managing team interactions.'
	}
}
